import type { EntityComboboxValidity } from "@/components/shared/EntityCombobox";
import { GroupCombobox } from "@/components/shared/GroupCombobox";
import { Button } from "@/components/ui/button";
import { useId } from "react";

export const CHECKLIST_GROUP_HELP =
    "Organizations in this group can use the checklist.";
export const CHECKLIST_GROUP_REFUSED =
    "This group can't be used for this checklist. Choose another group or remove it.";

interface IProps {
    value: number | null;
    onChange: (id: number | null) => void;
    onValidityChange?: (validity: EntityComboboxValidity) => void;
    refused?: boolean;
    disabled?: boolean;
    showValidation?: boolean;
    help?: string;
}

export const ChecklistGroupField = ({
    value,
    onChange,
    onValidityChange,
    refused = false,
    disabled = false,
    showValidation,
    help = CHECKLIST_GROUP_HELP,
}: IProps) => {
    const labelId = useId();

    return (
        <div
            role="group"
            aria-labelledby={labelId}
            className="flex min-w-0 flex-col gap-1.5"
        >
            <span id={labelId} className="text-foreground text-sm font-medium">
                Group
            </span>
            <div className="flex min-w-0 flex-wrap items-start gap-2">
                <div className="min-w-0 flex-1 basis-56 [&_[data-slot=combobox-trigger]]:w-full">
                    <GroupCombobox
                        value={value}
                        onChange={onChange}
                        onValidityChange={onValidityChange}
                        disabled={disabled}
                        error={refused}
                        helperText={refused ? CHECKLIST_GROUP_REFUSED : help}
                        name="organization_group_id"
                        labelId={labelId}
                        showValidation={showValidation}
                    />
                </div>
                {value !== null && (
                    <Button
                        type="button"
                        variant="outline"
                        disabled={disabled}
                        onClick={() => onChange(null)}
                    >
                        Remove group
                    </Button>
                )}
            </div>
        </div>
    );
};
